import React from 'react'
import './ProductListingHero.scss'

export const ProductListingHero = () => {
    return (
        <div className='listing-hero fs-8 flex flex-justify-center flex-align-center'>
            <h2 className='center'>
                <span className='block m-b-4'>Horse equipment</span>
                <span className='block'>for you!</span>
            </h2>
        </div>
    )
}
